/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BIMBaseCheck } from './bIMBaseCheck';
import { LOICheckRule } from './lOICheckRule';
import { ProjectFile } from './projectFile';
import { User } from './user';

export interface IFCCheck { 
    id?: string;
    uuid?: string;
    checkDate?: Date;
    projectFile?: ProjectFile;
    checker?: User;
    results?: string;
    completed?: boolean;
    nextPollAt?: Date;
    pollCount?: number;
    lodType?: IFCCheck.LodTypeEnum;
    loiCheckRule?: LOICheckRule;
    workflowRuleId?: string;
    workflowRuleName?: string;
    bimBaseCheck?: BIMBaseCheck;
    checkRuleType?: IFCCheck.CheckRuleTypeEnum;
    checkType?: IFCCheck.CheckTypeEnum;
    projectID?: number;
}
export namespace IFCCheck {
    export type LodTypeEnum = 'LOD_100' | 'LOD_200' | 'LOD_300' | 'LOD_400' | 'LOD_500';
    export const LodTypeEnum = {
        _100: 'LOD_100' as LodTypeEnum,
        _200: 'LOD_200' as LodTypeEnum,
        _300: 'LOD_300' as LodTypeEnum,
        _400: 'LOD_400' as LodTypeEnum,
        _500: 'LOD_500' as LodTypeEnum
    };
    export type CheckRuleTypeEnum = 'LOI' | 'IDS' | 'HYBRID' | 'AI';
    export const CheckRuleTypeEnum = {
        LOI: 'LOI' as CheckRuleTypeEnum,
        IDS: 'IDS' as CheckRuleTypeEnum,
        HYBRID: 'HYBRID' as CheckRuleTypeEnum,
        AI: 'AI' as CheckRuleTypeEnum
    };
    export type CheckTypeEnum = 'QUALITY' | 'HOAI' | 'IFC' | 'BASE' | 'SWM' | 'MY_CHECK';
    export const CheckTypeEnum = {
        QUALITY: 'QUALITY' as CheckTypeEnum,
        HOAI: 'HOAI' as CheckTypeEnum,
        IFC: 'IFC' as CheckTypeEnum,
        BASE: 'BASE' as CheckTypeEnum,
        SWM: 'SWM' as CheckTypeEnum,
        MYCHECK: 'MY_CHECK' as CheckTypeEnum
    };
}